<script>
    import Select from "svelte-select";
    import { getCities } from "../../services/addressService";
    import toast from "svelte-french-toast";

    let cities = [];
    export let value;
    export let handleChange;
    export let handleBlur;
    export let required = true;
    export let isSearchBar = false;
    export let cityName;
    export let clearable = false;
    export let error;
    export let groupId = undefined;
    let filterText = "";

    async function searchCityByName(filterText) {
        if (!(filterText.trim())) {
            return [];
        }

        await getCities(filterText, groupId).then((data) => {
            cities = data?.data?.map((city) => {
                return {label: `${city.name} - ${city.province}`, value: city}
            });
        }).catch((err) => {
            if(err?.response?.status === 500) {
                toast.error(`Errore durante la ricerca delle città, errore ${err.toString()}`);
            }
        });
        return cities;
    }

    let topConfig = {
        placement: 'top-start'
    };

    $: emptySlotMessage = (value) => !!value ? "Nessuna città trovata" : "Digita per trovare la città";
</script>

<div class="w-full">
     <Select
        {cities}
        id="city"
        type= "text"
        debounceWait="350"
        loadOptions={searchCityByName}
        floatingConfig={topConfig}
        required={required}
        clearable={clearable}
        bind:value
        bind:filterText
        bind:hasError={error}
        on:change={handleChange}
        on:blur={handleBlur}
        on:input={(val) => cityName = val?.detail?.value?.name}
        placeholder="Nome della città"
        class={`${isSearchBar ? "" : "hover:shadow-md"} transition-all select-error-border`}
        containerStyles={`
            border-radius: 0px;
            border: 1px solid #e0e0e0;
            ${isSearchBar ? '': 'box-shadow: 0px 1px 4px 0px rgb(0 0 0 / 15%)'};
            ${isSearchBar ? "max-height: 2rem !important; min-height: 2.75rem;" : ""}`
        }
    >
        <div slot="empty" class="flex justify-center items-center h-20">{emptySlotMessage(filterText)}</div>
    </Select>

    {#if error}
        <div class="pl-3 text-red-500">{error}</div>
    {/if}
</div>
